// extracted by mini-css-extract-plugin
export default {"inner":"Competitions_inner__rMILS","head":"Competitions_head__DMWlY","wrapper":"Competitions_wrapper__r-Iq-","button":"Competitions_button__G4LUf"};